import(/* webpackMode: "eager" */ "/dashphil/app/global-error.tsx")